import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import SubcontractModules from './modules/Subcontract'
import ProcessModules from './modules/Process'
import PartnerModules from './modules/Partner'
import SampleModules from './modules/Sample'
import ContractNegotiation from './modules/Negotiation/components'

const New = lazy(() => import('./components/New'))
const List = lazy(() => import('./components/List'))
const DetailBusiness = lazy(() =>
    import('./components/Detail').then((m) => ({ default: m.DetailBusiness }))
)
const Overview = lazy(() => import('./components/Overview'))

const ContractModule: RouteObject = {
    path: 'contracts',
    children: [
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'overview/:type',
            element: <Overview />,
        },
        {
            path: '',
            element: <List />,
        },
        {
            path: ':contractID',
            element: <DetailBusiness />,
        },
        {
            path: ':contractID/subcontracts/:subcontractID',
            element: <SubcontractModules.Detail />,
        },
        {
            path: ':contractID/processes',
            element: <ProcessModules.List />,
        },
        {
            path: 'partners',
            element: <PartnerModules.List />,
        },
        {
            path: 'partners/suppliers/:partnerID',
            element: <PartnerModules.SupplierDetail />,
        },
        {
            path: 'partners/:contractID',
            element: <PartnerModules.Detail />,
        },
        {
            path: 'samples',
            element: <SampleModules.List />,
        },
        {
            path: 'negotiations',
            element: <ContractNegotiation.List />,
        },
        {
            path: 'negotiations/:id',
            element: <ContractNegotiation.Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ContractModule
